import {
  Card,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { formatTimesheetDate } from "../utils/timesheetUtils";

const TimesheetCard = ({ 
  item, 
  index, 
  type, 
  selectedTimesheets,
  onCheckboxChange,
  onCardClick,
  TEXT_IN_PROGRESS 
}) => {
  return (
    <Card
      key={`${type}-${index}`}
      className="pagelist-content"
      sx={{
        marginTop: "0px",
        backgroundColor: type === "inprocess" ? "#d9d1d1" : "white"
      }}>
      <ListItem sx={{ m: 0, cursor: "pointer" }} disablePadding secondaryAction={item.isSent && <SendIcon color="disabled" />}>
        <ListItemButton
          sx={{ p: 0, pl: item?.isSent ? 1 : 2 }}
          onClick={() => onCardClick(item, index, type)}>
          <ListItemIcon sx={{ minWidth: "10px" }}>
            {!item.isSent && !item.timesheetStatus === false && (
              <Checkbox
                size="medium"
                edge="start"
                checked={selectedTimesheets.includes(item)}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => onCheckboxChange(item, e.target.checked)}
              />
            )}
          </ListItemIcon>
          <ListItemText
            primary={formatTimesheetDate(item.timesheetDate)}
            secondary={
              type === "inprocess"
                ? TEXT_IN_PROGRESS
                : `${item?.noOfJobs} Jobs, ${item?.totalHours} Hours`
            }
          />
        </ListItemButton>
      </ListItem>
    </Card>
  );
};

export default TimesheetCard;
